import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from "react-redux-toastr";
import {Loader} from "../Common/Loader";
import WordCloudMasonry from "../Common/WordCloudMasonry";
import BreadCrumbs from "../Common/BreadCrumbs";
import {getTagCloudDetails, updateTagId, projectListingGrid} from "../../actions/DashboardAction";
import {eventTracking} from "../../actions/UserAction";
import ProjectListing from "../Common/ProjectListing";
import {getAuthUserFullName, updateUserTagClickLocalStorage} from "../../actions/Common";
import {getStory} from "../../actions/Story";
import {testTags} from "../../utils";
import DefaultWordCloud from "../WordCloud/DefaultWordCloud";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader : false,
            showLoadMore: true,
            tagId : '',
            pageCounter : 1,
            userFirstName : getAuthUserFullName(),
            breadCrumbs : [{
                id: "dashboard",
                text: "My earthDECK"
            }]
        };
    }

    componentWillMount(){
        if (this.props.tagCloudDetail.length == undefined){
            this.setState({ showLoader: true });
            this.props.getTagCloudDetails("", "", "", (response)=>{
                if(response != undefined) {
                    this.setState({ showLoader: false });
                    if (response.data.length === 0) {
                        window.location.assign('/registration-success');
                    }
                }
            });
        }

        let pathArray = window.location.pathname.split( '/' );
        const tId = pathArray[2];

        if(tId != undefined) {
            this.props.projectListingGrid(tId, 1, true, (response) => {
                //this.setState({ showLoader: false });
                this.props.updateTagId(tId);

                if(response && response.data.length < 10){
                    this.setState({
                        showLoader: false,
                        showLoadMore: false
                    });
                }else{
                    this.setState({
                        showLoader: false,
                        pageCounter: this.state.pageCounter+1,
                        showLoadMore: true
                    });
                }

                setTimeout(function () {
                    const projectList = document.getElementById('projectTop');
                    
                    if (projectList) {
                        projectList.scrollIntoView();
                    }
                }, 1000);
            });
            updateUserTagClickLocalStorage({tagId : pathArray[2] , tagName : pathArray[3]});
            this.setState(prevState => ({
                breadCrumbs: [{
                    id: "dashboard",
                    text: "My earthDECK"
                },{
                    id: pathArray[2],
                    text: pathArray[3]
                }]
            }))
        }
    }

    projectDetails = (tagId) => {
       this.setState({tagId : tagId});
    }

    onTagsEventClick = (tagId, tagName) => {
        /* Action tracking */
        let originRoute = document.referrer;
        let destinationRoute = window.location.href;
        let date = new Date();
        let type = `WordSelected:${tagId}`;
        let postData = {type: type, originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
        this.props.eventTracking(postData);
        /* Action tracking */
        this.props.updateTagId(tagId);
        this.setState({ pageCounter: 1, showLoader: true });
        this.props.projectListingGrid(tagId, 1, true, (response) => {
            if(response && response.data.length < 10){
                this.setState({ pageCounter: 1, showLoader: false, showLoadMore: false });
            }else{
                this.setState({ pageCounter: 2, showLoader: false, showLoadMore: true });
            }
            setTimeout(function () {
                const projectList = document.getElementById('projectTop');

                if (projectList) {
                    projectList.scrollIntoView();
                }
            }, 1000);
        });

        this.setState(prevState => ({
            breadCrumbs: [{
                id: "dashboard",
                text: "My earthDECK"
            },{
                id: tagId,
                text: tagName
            }]
        }))
        updateUserTagClickLocalStorage({tagId : tagId , tagName : tagName});
    };


    onLoadMoreClick = (tagId) => {

        this.props.projectListingGrid(tagId,this.state.pageCounter, false, (response) => {
            if(response && response.data.length < 10){
                this.setState({ showLoadMore: false });
            }else{
                this.setState({ pageCounter: this.state.pageCounter+1, showLoadMore: true });
            }
        });
    };

    /**
     * Render dashboard
     * @returns {*}
     */
    render(){
        const tagCloudDetail = (this.props.tagCloudDetail)?this.props.tagCloudDetail:[];
        const showLoadMore = this.state.showLoadMore;

        if(tagCloudDetail.length > 0 && !this.state.showLoader) {
            return (
                <div>
                    <section className="dashboard-page">
                        <div className="row">
                            <div className="medium-12 columns">
                                <BreadCrumbs breads={this.state.breadCrumbs} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="medium-12 columns">
                                <h2 className="page-heading top-heading">
                                    {this.state.userFirstName} earthDECK 
                                    {/*<span className="fr tooltip-wrapper">
                                        <i className="icon-question"></i>
                                        <span className="text-center tooltip-box">
                                            The word cloud maps the tags generated by your click as you watched the film. clicking a tag on the word cloud brings up a list of stories related to that tag.
                                        </span>
                                    </span>*/}
                                </h2>
                                <p className="info-text">
                                   This word cloud shows the tags you chose with your clicks during the film. Follow these tags to stories.
                                </p>
                                <div className="tag-banner shadow-box m-t30">
                                    {/*<img src="assets/images/eathdeck/word-cloud-correction-small.png" />*/}
                                    {/*<WordCloudMasonry onClick={this.onTagsEventClick} tagCloudDetail={tagCloudDetail} projectDetails={this.projectDetails} />*/}
                                    <DefaultWordCloud onClick={this.onTagsEventClick} tagCloudDetail={tagCloudDetail} projectDetails={this.projectDetails} />
                                    {/*<WordCloud onClick={this.onTagsEventClick} tagCloudDetail={tagCloudDetail} projectDetails={this.projectDetails} />*/}
                                </div>
                            </div>
                        </div>
                        <div id="projectTop">
                            <ProjectListing showLoadMore={showLoadMore} tagId={this.state.tagId} onClick={this.onTagsEventClick} onLoadMoreClick={this.onLoadMoreClick} />
                        </div>
                    </section>
                </div>
            );
        } else {
            return <Loader/>
        }
    }
}

//Map state to props
function mapStateToProps(state, localProps) {
        let returnObj = {};
        if(typeof state.dashboard.tagCloudDetail != 'undefined'){
            returnObj.tagCloudDetail = state.dashboard.tagCloudDetail;
        }
    return returnObj;
}
//Connect action to component
export default connect(mapStateToProps,
    {getTagCloudDetails,updateTagId, projectListingGrid, getStory, eventTracking}
)(Dashboard);



// WEBPACK FOOTER //
// ./components/Dashboard/Dashboard.js